import { HeaderService } from '@patsnap-utils/biz';

export const headerService = new HeaderService();
